<template>
  <div>
    <Header />
    <div class="termBox">
      <CustomerNotice v-if="selected === 7"/>
      <UserAgreement v-else-if="selected === 6"/>
      <PrivatePolicy v-else/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header';
import Footer from '../components/Footer';

import PrivatePolicy from './PrivatePolicy';
import UserAgreement from './UserAgreement';
import CustomerNotice from './CustomerNotice';
export default {
  components: {
    Header,
    Footer,
    PrivatePolicy,
    UserAgreement,
    CustomerNotice
  },
  computed: {
    selected() {
      return ~~this.$route.query.selected;
    }
  }
};
</script>

<style lang="less">
.termBox {
  margin: 30px;
  padding: 30px 60px;
  box-sizing: border-box;
  box-shadow: 0px 5px 5px 5px #eee;
}

.termDetails {
  font-size: 15px;
  line-height: 23px;
  padding: 0 48px 10px;
  color: rgba(0, 0, 0, .8);
  font-weight: 400;
  white-space: pre-wrap;
  text-align: left;

  .title {
    text-align: center;
    width: 100%;
    color: rgba(0, 0, 0, .9);
  }

  .lg {
    font-size: 16px;
    line-height: 24px;
  }

  p {
    margin-top: 10px;
    margin-block-start: 0;
    margin-block-end: 0;
  }

  .italic {
    font-style: italic;
  }

  .underline {
    text-decoration: underline;
  }

  .bold {
    color: black;
    font-weight: bold;
  }

  .close {
    margin-top: 5px;
  }

  .indent {
    text-indent: 32px;
  }

  .atRight {
    text-align: right;
  }

  img {
    width: 100%;
    object-fit: cover;
  }
}
</style>
